import { Box, Typography } from '@mui/material'

const DriverNotSelected = () => {
  return (
    <Box p={2}>
      <Typography style={{ fontWeight: 'bold' }}>
        No drivers were selected. Please select a driver.
      </Typography>
    </Box>
  )
}

export default DriverNotSelected
